import { p as passMatrixBuild } from "../../../../../chunks/utils.js";
import { readFile } from "fs/promises";
import "path";
import { g as getForm } from "../../../../../chunks/getForm.js";
const games22Path = "src/pulse_past.json";
const filePath = "src/_games.json";
const prerender = false;
const games = JSON.parse(await readFile(filePath, "utf8"));
const games22 = JSON.parse(await readFile(games22Path, "utf8"));
async function load({ fetch, params }) {
  const data = (
    // (await read("/" + path.resolve("./") + "/" + filePath).json())[params.id] ??
    games[params.id] ?? games22[params.id] ?? // (await read("/" + path.resolve("./") + "/" + games22Path).json())
    // [
    //   params.id
    // ] ??
    await (await fetch(
      `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games/${params.id || ""}.json`
    )).json()
  );
  const homepasses = passMatrixBuild(data, "home");
  const awaypasses = passMatrixBuild(data, "away");
  const hometeamform = await getForm(
    // data.homeid,
    data?.homeid,
    params.id,
    // JSON.parse(JSON.stringify(games))
    structuredClone(games)
    // games
  );
  const awayteamform = await getForm(
    data.awayid,
    params.id,
    // JSON.parse(JSON.stringify(games))
    // games
    structuredClone(games)
  );
  return {
    id: params.id,
    match: data,
    // headtohead: headtohead.slice(0, 5),
    hometeamform: hometeamform.slice(0, 5),
    awayteamform: awayteamform.slice(0, 5),
    // passes: newmatrix,
    // // lineup: colNames,
    // lineup: newcolNames,
    // // rowNames: rowNames,
    // rowNames: newrowNames,
    // colNames: newcolNames,
    // playerRoles: playerRoles, //dt[2],
    homepasses,
    awaypasses
  };
}
export {
  load,
  prerender
};
